import { render, staticRenderFns } from "./NavidadView.vue?vue&type=template&id=0bb778ce&"
import script from "./NavidadView.vue?vue&type=script&lang=ts&"
export * from "./NavidadView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports